// src/formBuilder/utils/formUtils.js
export const getDefaultField = (type) => ({
    id: Date.now(),
    type,
    label: `${type} field`,
    name: `${type}_${Date.now()}`,
    required: false,
    width: "full",
    options: type === "select" || type === "radio" ? ["Option 1", "Option 2"] : [],
    validation: { minLength: "", maxLength: "", pattern: "" },
});
